// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__3BEy3","icon":"Header_icon__3EBiz","phone":"Header_phone__2HXUv","location":"Header_location__2-DxC","mail":"Header_mail__3CGZx"};